import type { ActionDefinition } from '@gzl10/nexus-sdk'

/**
 * Row action — toggles plugin enabled/disabled state via ctx.core.plugins.enable/disable()
 */
export const togglePluginAction: ActionDefinition = {
  key: 'toggle',
  scope: 'row',
  group: { en: 'Plugin Management', es: 'Gestión de plugins' },
  label: { en: 'Toggle', es: 'Activar/Desactivar' },
  icon: 'mdi:toggle-switch',
  output: {},

  confirm: {
    type: 'simple',
    message: { en: 'Changing plugin state will restart the server.', es: 'Cambiar el estado del plugin reiniciará el servidor.' },
    severity: 'warning'
  },

  input: {
    enabled: {
      label: { en: 'Enabled', es: 'Habilitado' },
      input: 'checkbox',
      required: true
    }
  },

  select: ['name', 'enabled'],

  handler: async (ctx, input) => {
    const { enabled, _record } = input as { enabled: boolean; _record: { name: string } }
    const name = _record.name

    ctx.events.notify('audit.log', {
      source: 'core:plugins',
      action: 'plugin_toggled',
      resourceType: 'plugin',
      resourceId: name,
      metadata: { enabled }
    })

    try {
      if (enabled) {
        ctx.core.plugins.enable(name)
      } else {
        ctx.core.plugins.disable(name)
      }
    } catch (error) {
      throw new ctx.core.errors.AppError((error as Error).message, 404)
    }

    ctx.core.logger.info({ name, enabled }, 'Plugin toggled, scheduling restart')

    setTimeout(() => {
      process.exit(0)
    }, 500)

    return {
      success: true,
      message: `Plugin ${name} ${enabled ? 'enabled' : 'disabled'}. Server restarting...`
    }
  }
}
